import { isWeb, navigateTo, navigationRef } from '@helpers';
import { MODAL_ANIMATION_TIMING } from '@v2/pages/common/constants/base.constants';

/**
 * Sequential-pop navigation from OP Settings back to Machines.
 *
 * Normal flow: pop Settings first so its slide-down animation plays, then after
 * it completes pop the OperatorPanel via navigate so OP also slides down. A
 * single multi-pop only animates the top card in the batch.
 *
 * Target 'Authorized' on both platforms — it is the root stack screen that
 * hosts MachinesNavigation on web; 'Machines' is nested inside it and is not
 * a root route, so navigate('Machines') from the root context wouldn't pop.
 */
export const goToMainApp = () => {
  if (navigationRef.current?.canGoBack()) {
    navigationRef.current.goBack();
    setTimeout(() => {
      navigationRef.current?.navigate('Authorized');
    }, MODAL_ANIMATION_TIMING);
  } else {
    // Deep-link fallback: nothing above the main app in the stack, push directly.
    // Keep the platform split so the existing tabNavigationRef fallback in the
    // navigateTo helper still fires for web's nested 'Machines' route.
    navigateTo(isWeb ? 'Machines' : 'Authorized');
  }
};
